import React from "react";

const MenuAperitivo = () => {
	return (
		<section className="module">
			<div className="container">
				<div className="row">
					<div className="col-sm-2 col-sm-offset-5">
						<div className="alt-module-subtitle">
							<span className="holder-w"></span>
							<span className="holder-w"></span>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-sm-8 col-sm-offset-2">
						<h2 className="module-title font-alt">Fioreria di Aperitivi</h2>
					</div>
				</div>
				<div className="row multi-columns-row">
					<div className="col-sm-6">
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">
										<b>RUSPE, PARCHEGGI E L'ARSURA</b>
									</h4>
									<div className="menu-detail font-serif"></div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt"></h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">lupino nascosto</h4>
									<div className="menu-detail font-serif">ANALCOLICO FORTE / ADAGIO</div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€8</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">rabarbatonic</h4>
									<div className="menu-detail font-serif">AMARO RBR, SODA E ROSMARINO</div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€8</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">felce</h4>
									<div className="menu-detail font-serif">SPRITZ PICCANTINO CON AMARO RBR</div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€8</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">narciso</h4>
									<div className="menu-detail font-serif">
										AMERICAN RBR, AMARO, LIMONE E ACETO
									</div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€8</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">Acido Fiorito</h4>
									<div className="menu-detail font-serif">Sour Limonoso</div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€8</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">rosolaccio</h4>
									<div className="menu-detail font-serif">MITO ALL'ITALIANA</div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€8</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">gerbera</h4>
									<div className="menu-detail font-serif">NEGRONI, BALSAMICO E BERGAMOTTO</div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€9</h4>
								</div>
							</div>
						</div>
					</div>
					<div className="col-sm-6">
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">
										<b>L'UMARELL RINCASANTE C'HA SETE.</b>
									</h4>
									<div className="menu-detail font-serif"></div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt"></h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">boulevardier in rose</h4>
									<div className="menu-detail font-serif">BOURBON WHISKY e MARASCHINO</div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€12</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">gin tonic botanico</h4>
									<div className="menu-detail font-serif">
										GIN AL CAPPERO, ROSMARINO E BERGAMOTTO
									</div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€12</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">citrus blossom</h4>
									<div className="menu-detail font-serif">WHISKY, LIMONE E SODA</div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€11</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">ninfea</h4>
									<div className="menu-detail font-serif">TEQUILA, POMPELMO, SALE E PEPE</div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€11</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">fitz in fiore</h4>
									<div className="menu-detail font-serif">GIN FIZZ, YUZU E GELSOMINO</div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€12</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">fior di burrasca</h4>
									<div className="menu-detail font-serif">RHUM, FRAMBOISE, SELTZ E LIME</div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€11</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">canna e sale</h4>
									<div className="menu-detail font-serif">
										MEZCAL, ANANAS ACIDULATO E SALE FUMEE'
									</div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€11</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">martini all'olio</h4>
									<div className="menu-detail font-serif">
										CON GIN A BASE OLIO DI SARA MARELLI
									</div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€12</h4>
								</div>
							</div>
						</div>
					</div>
				</div>
				<br />
				<div className="row multi-columns-row">
					<div className="col-sm-6">
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">
										<b>VIGNE IN CENTRO</b>
									</h4>
									<div className="menu-detail font-serif"></div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt"></h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">LE BOLLE.</h4>
									<div className="menu-detail font-serif">
										una piccola selezione che sboccia in settimana. un metodo classico, una
										bollicina tranquilla, un ritermentato anarchico e, che ci scappa sempre, uno
										champagne
									</div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">da €8 a €15</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">L'IMMOBILE SCURO</h4>
									<div className="menu-detail font-serif">
										rossi che abitano qui in rotazione, uno Leggero, uno più serio e uno che mette
										le radici. li scegliamo noi a seconda dell'umore della cantina.
									</div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">da €8 a €12</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">IL FERMO CHIARO O AMBRATO.</h4>
									<div className="menu-detail font-serif">
										bianchi, macerati, cose che hanno visto un po' di sole. uno secco, uno
										aromatico, un filo ombroso. ci piace cambiare quindi chiedete e vi sarà versato.
									</div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">da €8 a €13</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">LUPPOLO FIORENTE TRA LE BENNE.</h4>
									<div className="menu-detail font-serif">
										SELEZIONE DI BIRRETTE CHE CAMBIAMO DI VOLTA IN VOLTA, L'OSTE POTREBBE SAPERLO. E
										POTREBBE BERLE.
									</div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€7</h4>
								</div>
							</div>
						</div>
					</div>
					<div className="col-sm-6">
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">
										<b>POI SE SCAPPA QUALCHE EXTRA, STUDIAMOLA E PROVIAMOCI...</b>
									</h4>
									<div className="menu-detail font-serif"></div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt"></h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">PIC-NIC TRA FIORI E RUSPE.</h4>
									<div className="menu-detail font-serif"></div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt"></h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">RINFORZINO</h4>
									<div className="menu-detail font-serif">
										Sai già che avrai fame? Arriviamo con il carico doppio
									</div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€4 cad</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">PANE AL VAPORE</h4>
									<div className="menu-detail font-serif">
										La base di formaggio olandese c'è, le erbette pure...
									</div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt"></h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">COL SALUME DELLA DISPENSA</h4>
									<div className="menu-detail font-serif">quel che passa dal salumaio</div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€8</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">VEGETAL DALL'ORTO DI CANTIERE</h4>
									<div className="menu-detail font-serif">un mix delicato e genuino</div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€8</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">COL PESCE DELLA BRACE</h4>
									<div className="menu-detail font-serif">
										un mix di pesce in dadolata passato dalla griglia con insalata russa e caviale
										di frutta
									</div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€10</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">MANICARETTI DEL FIORISTA.</h4>
									<div className="menu-detail font-serif">
										Manicaretti di carne, pesce o d'orto che nascono da ciò che fiorisce in dispensa
										RBR, o dall'umore del fiorista Oste. Tutto spiegato a voce.
									</div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">da €8 a €15</h4>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default MenuAperitivo;
